module.exports = __webpack_public_path__ + "static/img/254_TO8_2256_og.b1a244c.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/254_TO8_2256_og.jpg
// module id = s/+W
// module chunks = 0